import BrainstormIdeasTemplate from "../../Templates/BrainstormIdeas";

export default function BrainstormIdeasPage() {
    return (
        <BrainstormIdeasTemplate />
    )
}